import React from "react";
import styles from "./Terms.module.css";

const Terms = () => {
  return (
    <div className={styles.container}>
      <h1>Termos de Uso</h1>

      <p>
        Ao acessar e utilizar o site Fohattech, você concorda com os termos e
        condições descritos nesta página.
      </p>

      <h2>Uso do site</h2>
      <p>
        O usuário concorda em utilizar o site apenas para fins legais e de forma
        que não prejudique o funcionamento da plataforma.
      </p>

      <h2>Responsabilidade</h2>
      <p>
        O Fohattech não se responsabiliza por danos diretos ou indiretos
        causados pelo uso das ferramentas disponíveis no site.
      </p>

      <h2>Disponibilidade</h2>
      <p>
        O site pode ser atualizado, modificado ou interrompido a qualquer
        momento sem aviso prévio.
      </p>

      <h2>Propriedade intelectual</h2>
      <p>
        Todo o conteúdo do site, incluindo textos, design e funcionalidades,
        pertence ao Fohattech.
      </p>

      <h2>Alterações</h2>
      <p>
        Os termos podem ser modificados a qualquer momento, sendo recomendado
        revisá-los periodicamente.
      </p>
    </div>
  );
};

export default Terms;